<template>
   <v-container>
     <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <h1>Customize with CSS</h1>
            </v-col>
            <v-col class="flex-end" cols="6">
              <v-btn
                @click="updateCss"
                :disabled="!newCssToBeUpdated"
                outlined
                medium
                rounded
                class="theme-main-color"
              >
                Update cashier
                <v-icon class="pl-2">mdi-reload</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <p>All type of styling you want is achievable with custom CSS.</p>
          <prism-editor
            class="css-editor"
            @change="setNewCss"
            :code="code"
            language="css"
          ></prism-editor>
        </v-col>
     </v-row>
   </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import PrismEditor from 'vue-prism-editor'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  name: 'Css-customization',
  components: {
    PrismEditor
  },
  data: () => ({
    code: null,
    newCssToBeUpdated: false,
    newCss: ''
  }),
  methods: {
    ...mapMutations([
      'updateSpecificCssPreset',
      'reloadCashierMutation'
    ]),
    setNewCss (cssInput) {
      this.code = cssInput
      this.newCssToBeUpdated = Boolean(cssInput)
    },
    updateCss () {
      const cssObject = {
        css: this.code,
        preset: this.preset
      }
      this.updateSpecificCssPreset(cssObject)
      this.reloadCashierMutation()
      this.newCssToBeUpdated = false
    }
  },
  computed: {
    ...mapState({
      theme: ({ theme }) => theme.theme,
      customCss: ({ theme }) => theme.customCss,
      preset: ({ config }) => config.preset
    })
  },
  created () {
    const customCss = this.customCss && this.customCss[this.preset]
    this.code = customCss
  }
}
</script>

<style>
.v-application code {
  background: transparent!important;
}
.flex-end {
  display:flex;
  justify-content:flex-end
}
</style>
